import { request } from '../auth/client';
import type {
  CredentialCreateInput,
  CredentialListQuery,
  CredentialRotateInput,
  CredentialRow,
  CredentialTestResponse,
  CredentialUpdateMultiplierInput,
  PaginatedResponse,
} from '@runik/shared';

export const credentialsKey = (query?: Partial<CredentialListQuery>) =>
  ['credentials', { ...(query ?? {}) }] as const;

export function listCredentials(query: Partial<CredentialListQuery>) {
  const params = new URLSearchParams();
  if (query.page) params.set('page', String(query.page));
  if (query.limit) params.set('limit', String(query.limit));
  if (query.customerId) params.set('customerId', query.customerId);
  return request<PaginatedResponse<CredentialRow>>(`/api/credentials?${params.toString()}`);
}

export function createCredential(body: CredentialCreateInput) {
  return request<{ id: string; label: string; identifier: string; note?: string }>(
    '/api/credentials',
    {
      method: 'POST',
      body: JSON.stringify(body),
    },
  );
}

export function rotateCredential(id: string, body: CredentialRotateInput) {
  return request<{ id: string; identifier: string }>(`/api/credentials/${id}/rotate`, {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function testCredential(id: string) {
  return request<CredentialTestResponse>(`/api/credentials/${id}/test`, { method: 'POST' });
}

export function updateCredentialMultiplier(id: string, body: CredentialUpdateMultiplierInput) {
  return request<{ id: string; usageMultiplier: string }>(`/api/credentials/${id}/multiplier`, {
    method: 'PATCH',
    body: JSON.stringify(body),
  });
}

export function deleteCredential(id: string) {
  return request<void>(`/api/credentials/${id}`, { method: 'DELETE' });
}
